/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";

/**
 * Re-run an existing deployment.
 */
export type DeploymentSourceDeployment = {
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  deploymentId: string;
};

/** @internal */
export type DeploymentSourceDeployment$Outbound = {
  deploymentId: string;
};

/** @internal */
export const DeploymentSourceDeployment$outboundSchema: z.ZodType<
  DeploymentSourceDeployment$Outbound,
  z.ZodTypeDef,
  DeploymentSourceDeployment
> = z.object({
  deploymentId: z.string(),
});

export function deploymentSourceDeploymentToJSON(
  deploymentSourceDeployment: DeploymentSourceDeployment,
): string {
  return JSON.stringify(
    DeploymentSourceDeployment$outboundSchema.parse(deploymentSourceDeployment),
  );
}
